export default "__VITE_ASSET__BfwXCt2U__"